import {
    PreScreeningQuestion,
    QuestionType,
} from "../../types/landingPage";

/**
 * Simple test pre-screening questions for VACCINE_TEST_1
 * No attribute mapping - just asks about recent vaccine history
 */
export const vaccineTest1ScreeningQuestions: PreScreeningQuestion[] = [
  {
    id: "recentVaccine",
    type: QuestionType.RADIO,
    question: "Have you received a vaccine in the last 6 months?",
    helpText: "This includes any type of vaccine (flu, COVID, etc.)",
    required: true,
    allowBack: true,
    options: [
      {
        value: "yes",
        label: "Yes, I have received a vaccine in the last 6 months",
      },
      {
        value: "no",
        label: "No, I have not received a vaccine in the last 6 months",
      },
      {
        value: "unsure",
        label: "I'm not sure",
      },
    ],
    // No attribute mapping as requested
  },
];

